/**
 * Returns a callback that triggers the search with the selected suggestion.
 * @param {jQuery|Element} component
 * @returns {Function}
 */
const handleSuggestionSelect = (component) => (e) => {
    e.preventDefault();
    const suggestionText = $(e.target).text();
    $(component).find('.search__input')
        .val(suggestionText)
        .trigger('input');

    $(component).find('.search__form')
        .trigger('submit');
};

export default handleSuggestionSelect;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleSuggestionSelect.js